import {createSlice} from '@reduxjs/toolkit';
import {httpGet, httpPost} from '../../util/Rest';
import {DEBTOR} from '../../constants/MicroServiceConstants';
import {STATE, PHONE_TYPE} from '../../constants/Lookup';
import {deleteWorkQueueByAccountNumber} from './WorkQueue';
import {
  clearWindowError,
  deleteModifiedWindowSessionItem,
  removeModifiedWindow,
} from "./ModifiedWindows";
import { POE_INFORMATION } from "../../util/Content";

const initialData = {
  poeData: {},
  dropDownData: {},
  poeStatus: null,
  isLoading: false,
  errorMsg: null,
  successMsg: null,
};

const slice = createSlice({
  name: 'poe',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    fetchPoeData: (state, action) => {
      state.poeData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchDropDownData: (state, action) => {
      state.dropDownData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    postPoeData: (state, action) => {
      state.poeStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
    },
    resetPoeStatus: (state) => {
      state.poeStatus = null;
      state.isLoading = false;
    },
    resetMsg: (state) => {
      state.errorMsg = null;
      state.successMsg = null;
      state.isLoading = false;
      state.poeStatus = null;
    },
    fetchError: (state, action) => {
      state.errorMsg = action?.payload?.data?.error ? action.payload.data.error : action.payload;
      state.isLoading = false;
    },
    resetData: (state) => {
      state.poeData = {};
    },
  },
});

export default slice.reducer;

// Actions

const {
  fetchPoeData,
  fetchDropDownData,
  resetMsg,
  postPoeData,
  fetchStart,
  resetPoeStatus,
  fetchError,
  resetData,
} = slice.actions;

export const fetchPoe = (accountNumber) => {
  return (dispatch) => {
    dispatch(fetchStart());
    Promise.all([
      httpPost('lookup/find/all/lookup', {
        typeCode: [STATE, PHONE_TYPE],
      }),
      httpGet(`${DEBTOR}/find/poe/${accountNumber}`),
    ])
      .then((data) => {
        const lookUpApiData = data && data[0] ? data[0] : null;
        const poeData = data && data[1] ? data[1] : null;
        if (lookUpApiData && lookUpApiData.status && lookUpApiData.status === 200) {
          dispatch(fetchDropDownData(lookUpApiData.data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
        if (poeData && poeData.status && poeData.status === 200) {
          dispatch(fetchPoeData(poeData.response));
        } else {
          dispatch(fetchError(poeData.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const postPoe = ({isDirty, ...details}) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`${DEBTOR}/save/generalinfopoe`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(
            deleteWorkQueueByAccountNumber({accountNumber: details?.accountNumber, isDirty}),
          );
          dispatch(postPoeData(data));
          deleteModifiedWindowSessionItem(POE_INFORMATION);
          dispatch(removeModifiedWindow({ windowName: POE_INFORMATION }));
          dispatch(clearWindowError({ windowName: POE_INFORMATION }));
        } else {
          dispatch(fetchError(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const resetToast = () => {
  return (dispatch) => {
    dispatch(resetMsg());
  };
};
export const resetPoe = () => {
  return (dispatch) => {
    dispatch(resetPoeStatus());
  };
};
export const resetPOEdata = () => {
  return (dispatch) => {
    dispatch(resetData());
  };
};
